

import { Component, ViewChild } from '@angular/core'; 
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SalesService } from '../../services/sales.service';
import { ReportsComponent } from '../../more/reports/reports.component';
import { PaginationComponent } from '../../common/pagination/pagination.component';

@Component({
  selector: 'app-sales-detail',
  standalone: true,
  imports: [CommonModule,
    PaginationComponent],
  templateUrl: './sales-detail.component.html',
  styleUrls: ['./sales-detail.component.scss', '../../../app.component.scss']
})
export class SalesDetailComponent {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  productName: string = '';
  changedStorePeriod: string = '';
  public store_Id: string = "";
  public month_interval: string = "";

  storeDetails: any = {};
  selectedStockType: string = '';
  tableHeadings: string[] = [];
  modifiedHeadings: string[] = [];
  type: string = '';
  currentStoreId: string = '';
  monthInterval: string = '';
  public salesProducts: any = [];
  public storeSalesOrders: any[] = [];
  public paginationData: any;
  public currentPage: number = 1;

  constructor(private spinnerService: NgxSpinnerService,public salesService: SalesService,public location: Location,private route: ActivatedRoute){}

  goBack(){
    this.location.back();
  }

  ngOnInit() {
    this.route.params.subscribe(routeParams => {
      this.currentStoreId = routeParams.id;
      this.type = routeParams.type;
      this.getStoreSalesOrders(this.type, this.currentStoreId);
    });
    this.route.queryParams.subscribe(params => {
      this.productName = params['product_name'];
      this.changedStorePeriod = params['changedStore_Period']
    });
  }

  getStoreSalesOrders(type: string, storeId: string): void {
    this.salesService.getSalesProducts(type, storeId, this.currentPage, '', '').subscribe({
      next: (response: any) => {
        console.log(response, " data response ")
        const data = response.data;
        if (data && data.stocks) {
          this.paginationData = data.stocks;
          this.paginationData.totalPage = Math.floor(data.stocks.total / 10);
          this.salesProducts = data.stocks.data;
          this.tableHeadings = Object.keys(data.stocks.data[0]);
          this.modifiedHeadings = this.tableHeadings.map(heading => this.capitalizeAndReplace(heading));
        } else if (data){
          this.paginationData = response.data;
          this.paginationData.totalPage = Math.floor(response.data.total / 10);
          this.salesProducts = data.data;
          this.tableHeadings = Object.keys(this.salesProducts[0]);
          this.modifiedHeadings = this.tableHeadings.map(heading => this.capitalizeAndReplace(heading));
        } else {
          console.error('No sales orders data available');
        }
        console.log(this.paginationData, " paginationData");
      },
      error: (error: any) => {
        console.error('Error fetching store sales orders:', error);
      }
    });
  }

  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getStoreSalesOrders(this.type, this.currentStoreId);
  }

  capitalizeAndReplace(heading: string): string {
    // Split heading by underscore and capitalize each word
    const words = heading.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
    // Join words with space
    let formattedHeading = words.join(' ');
    // Replace "Store Name" with "Store", "Warehouse Name" with "Warehouse", and "Rfid" with "RFID"
    if (formattedHeading === "Store Name" || formattedHeading === "Warehouse Name") {
      formattedHeading = formattedHeading.split(' ')[0];
    } else if (formattedHeading === "Rfid") {
      formattedHeading = "RFID";
    }
    return formattedHeading; 
  }
  
  downloadSalesRecords(type: string, storeId: string){
    if (storeId && type) {
      this.salesService.downloadSalesRecords(type, storeId).subscribe((res) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(res);
        link.download = `${type}`;
        link.click();
      });
    } else {
      console.error('StoreId or type is undefined or null');
    }
  }

}

